import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function JobSeekerDashboard() {
  return (

        <div className="content-body">
          <div className="container my-4">
  <div className="row justify-content-center">
    <div className="col-md-8">
      <h2 className="mb-4 text-center">My Job Applications</h2>
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title">Software Developer</h5>
          <p className="card-text mb-1">
            <span className="badge bg-primary">Applied</span>
            <small className="text-muted ms-2">Submitted on: 01 Sep 2025</small>
          </p>
          <div className="progress mb-1" style={{height: '8px'}}>
            <div className="progress-bar bg-success" role="progressbar" style={{width: "40%;"}} aria-valuenow="40" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <small className="text-muted">Current Status: Under Review</small>
        </div>
      </div>
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title">UI Designer</h5>
          <p className="card-text mb-1">
            <span className="badge bg-warning text-dark">Interview Scheduled</span>
            <small className="text-muted ms-2">Scheduled for: 10 Sep 2025</small>
          </p>
          <div className="progress mb-1" style={{height: "8px;"}}>
            <div className="progress-bar bg-warning" role="progressbar" style={{width: "70%;"}} aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <small className="text-muted">Current Status: Awaiting Interview</small>
        </div>
      </div>
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title">React Frontend Engineer</h5>
          <p className="card-text mb-1">
            <span className="badge bg-danger">Rejected</span>
            <small className="text-muted ms-2">Last updated: 05 Sep 2025</small>
          </p>
          <div className="progress mb-1" style={{height: "8px;"}}>
            <div className="progress-bar bg-danger" role="progressbar" style={{width: "100%;"}} aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <small className="text-muted">Current Status: Application Closed</small>
        </div>
      </div>
    </div>
  </div>
</div>

        </div>
      
  );
}

export default JobSeekerDashboard;
